import { userOne } from '@alltrails/context/stubs/stubbedUser';
import { CustomRouteMap } from '../types/CustomRoute';

export const stubbedCustomRouteMap = {
  id: 53450256,
  name: 'Map - February 26, 2025',
  description: 'test - update3',
  description_lang: null,
  description_original: 'test - update3',
  description_source: 'test - update3',
  presentationType: 'map',
  slug: 'map-february-26-2025-13111c2',
  created_at: '2025-04-07T19:33:47Z',
  timezone: null,
  location: {
    postalCode: null,
    city: 'St. John',
    region: 'KS',
    country: 'US',
    country_id: 313,
    latitude: '38.20333',
    longitude: '-98.81078'
  },
  bounds: {
    latitudeTopLeft: '38.20333',
    latitudeBottomRight: '38.09996',
    longitudeTopLeft: '-98.86778',
    longitudeBottomRight: '-98.76226'
  },
  trailId: null,
  activity: {
    description: '',
    name: 'Hiking',
    uid: 'hiking',
    bitfieldPosition: 7,
    displayPriority: 11,
    type: 'activity'
  },
  rating: null,
  difficulty: null,
  comment: null,
  obstacles: null,
  ratingAttributes: [],
  infoAttributes: [],
  user: userOne,
  dataUid: null,
  associatedTrailReviewId: null,
  routeType: null,
  originalAtMapId: null,
  private: false,
  contentPrivacy: 'urn:alltrails:visibility:public',
  hidden: null,
  popularity: null,
  summaryStats: {
    duration: 470,
    updatedAt: '2025-04-14T18:09:25Z',
    elevationMax: 0,
    distanceTotal: 43404.56,
    elevationGain: 66,
    elevationLoss: 63
  },
  profilePhotoId: null,
  photoCount: 0,
  splits: null,
  routes: [
    {
      id: 53450256000,
      status: 'A',
      sequence_num: 1,
      lineGeoStats: {
        speedMax: 0.0,
        timeMoving: 0.0,
        timeTotal: 0.0,
        distanceTotal: 14617.499999999998,
        elevationGain: 28,
        elevationLoss: 21,
        elevationMax: 592,
        elevationMin: 585,
        elevationStart: 586,
        elevationEnd: 592,
        calories: 0,
        dateTimeStart: null,
        dateTimeStop: null
      },
      lineDisplayProperty: {
        color: '#f87559'
      },
      lineSegments: [
        {
          id: 534502560000000,
          dateTimeStart: null,
          dateTimeStop: null,
          sequence_num: 1,
          freeDraw: null,
          polyline: {
            pointsData:
              'yqdhFj~azQH?AjD?hD?rB?rB?rB@pB?rB?rB?rB?rB?rB?rB?rB@pB?rB?rB?rBlB@lB?lB@bBA`B?`BAbBA|A@~A?|A@~A?~A?`BA~A?`BA~A?~AA`B?~AA`B?~AAzA?zA?|A@zA?zA?zA?|A@zA?zA?~B?~B?NAxA?xA?xA@zA?xA?xA?xA@xA?xA?zA?xA@xA?xA?rDAfBAhBA|A?|A?|A?|A@~A?|A?|A?|A?tBAvBAL?r@@zA?zA?|A?zA?zA?zA?|A?zA?zA?zA?zAAxA?zAAzA?L?hB?jBAjA?fB@fB?fBBfBBpBEx@?~B@~B?bB?bB@bB?pB@fA?|AA|AAzAA|AA|AA|A@|A@|A?|A@|A@xA?dBAfB?dBAfBAdB?fBAj@?f@?bBDxA?`BA~ACzAAdB?bBAdB?pBDpBDH?lA@`BI`B?~AA`B?|A@~A@|A@|A@~A@|A@`BC`BEnB?pBAnB?|A?|A@|A?^?pB?nB?pB?`C?nA@lB?nBCpBCrB@rB?jA?bB?bB?bB?bB?dB?bB?bB?bB?bB@dB?bB@dB?dBAfB?dBA`B?~A@`B?`B?~A@`B?rB?tBA|A?|A?zA@|A?|A?|AA|A?zAAzA?zA?zA?zA?|A?zA?zA?zA?zA?zA@zA?zA?zA?zA?zA?|A?zA?zA?zA?zA?tB?rB?tB?dB@fB?dB@jB?jBA?bFChDAfD?rB?pB?rBArB?pB?rB?rB?rB?pBArB?rB?pB?rB',
            indexedTimeData: null,
            elevationData: null,
            indexedElevationData:
              '?_ctwnBgE?gE?gE~hbEgE?gE?gE?gE?gE?gE_ibEgE?gE_qdBgE_w|AgE?gE?gE_ibEgE?gE?gEnnqCgEnyo@gE_xq@gE_poCgE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE_ibEgE?gE_w|AgE_qdBgE?gE?gE~hbEgE~hbEgE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE_ibEgE_ibEgE?gE~hbEgE?gE_ibEgE?gE?gE~hbEgE?gE~hbEgE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE_ibEgE_hmFgEnkXgEn{sEgE~hbEgE?gE?gE?gE?gE?gE_ibEgE~hbEgE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE~hbEgE?gE?gE?gE?gE_|_CgE_laAgE?gE?gE?gE?gE_ibEgE~hbEgE~hbEgE?gE~hbEgE?gE?gE?gE_ibEgE?gE?gE_|BgE_l~DgE?gE?gE?gE?gE?gE_ibEgE_seKgE?gEo}@gEnvpDgE~cyKgE~hbEgE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE~k~DgE~{BgE?gE?gE?gE?gEo~oEgEostDgEn}@gEo}@gE?gE?gE?gE~{_CgE~kaAgE?gE?gE?gEostDgEotLgE?gE?gEn~rAgEninBgE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE_fiAgE~qy@gE~rNgE?gE?gE?gE?gE?gE_ibEgE?gE?gE?gE~c_DgE_d_DgE?gE_ibEgE?gE?gE?gE~hbEgE?gE?gE?gE?gE?gE?gE_ibEgE?'
          }
        },
        {
          id: 534502560000001,
          dateTimeStart: null,
          dateTimeStop: null,
          sequence_num: 2,
          freeDraw: null,
          polyline: {
            pointsData: 'wupgF`gezQ???`C?`CAbC?`C?`C?`C',
            indexedTimeData: null,
            elevationData: null,
            indexedElevationData: '?_wzcoBgE?gE?gE?gE?gE?gE_ibEgE?'
          }
        },
        {
          id: 534502560000002,
          dateTimeStart: null,
          dateTimeStop: null,
          sequence_num: 3,
          freeDraw: null,
          polyline: {
            pointsData: 'yupgFn_fzQ?rB?pBArB?rB?pB?rBArB?pB?rB?pB?rBArB?pB?rBeB?cB?eB?cB?eB?eB?cB?eB?',
            indexedTimeData: null,
            elevationData: null,
            indexedElevationData: '?_a~ioBgE_y}JgEnstDgEnzDgE?gE?gE?gE_ibEgE?gE~oRgE~wnDgE?gE_ibEgE?gE?gE?gE?gEnrbBgEorbBgE?gE?gE_ibEgE?'
          }
        }
      ],
      estimatedTimeToComplete: {
        value: '2.5–3',
        unit: 'hr'
      }
    },
    {
      id: 53450256001,
      status: 'A',
      sequence_num: 2,
      lineGeoStats: {
        distanceTotal: 23791.56,
        elevationGain: 33,
        elevationLoss: 33,
        elevationMax: 587,
        elevationMin: 578,
        elevationStart: 584,
        elevationEnd: 584,
        dateTimeStart: null,
        dateTimeStop: null
      },
      lineDisplayProperty: {
        color: '#64f67b'
      },
      lineSegments: [
        {
          id: 534502560010000,
          dateTimeStart: null,
          dateTimeStop: null,
          sequence_num: 1,
          freeDraw: null,
          polyline: {
            pointsData:
              'mn~gF|n`zQ?qAkB?kB?iBAkB?BqE@}B?{B?}B@}BBs@Cm@Ge@KQOSUQc@S@yA@}@D_BFkAJwAB_@Fm@L{AHw@JYASH[HaABaA@_B?sB@sB?sC@qC?oC@oC@aC?cC@sD@wCBwC@wC@qC@sC@qC?sC?uC@gC?gC@gC@gC?wB?wB?wB@eB@aBByC@oCAuA?sC@qC?sC@{B?{B@{B@}B?}B@{B?}B@}B`CA|AA|A?|AAzA?|AA|A?|AA|A?|AA|A?|AAzA?|AA|A?|AAzA?zA?zAAxA?zA?zA?zAAzA??sB?sB@cC@eC@cCAQIWQYSOa@UsA]_Ae@i@_@??h@^~@d@rA\\`@TRNPXHV@PAbCAdCAbC?rB?rBdB?fBAdB?D?fB?dB?fB?AtBAtB?rBAtBAtBAtBAtB?rBAtBAtBAtBAtBAtB?rBAtBAtBAtBAtB?rBAtBAtBAvBAxB?vBAvBAvBAxBAvB?vBAxBAvB?xB?xB?xB?vB?xB?xBAxB?xB?xB?vB?xB?xB?xB???tGsbAZm@@gAHyDp@aBVi@F_ADaBBq@?U?s@@UHKXIv@MzAGl@C^KvAGjAE~AA|@AxAb@RTPNRJPFd@Bl@Cr@CtNCpECzDn@CvB@R?r@Hx@Db@DtBLfABlA@VDd@@F?n@?v@Fn@J\\R@@\\VRNPNd@X`@J`AHh@B\\FfARJ@PT@J@H@L@FDHFDJ@HCHE?@IBIBKAGEEIAGAMAIAKQUKAgAS]Gi@CaAIa@Ke@YQOSO]WAA]So@Kw@Go@?G?e@AWEmAAgACuBMc@Ey@Es@IS?wBAo@BB{DBqE@}B?{B?}B@}BBs@Cm@Ge@KQOSUQc@S@yA@}@D_BFkAJwAB_@Fm@L{AHw@JYTIr@AT?p@?`BC~@Eh@G`BWzAW|AYfAIl@AxAAxA?xAAxA?xAAxA?zAAxAAxA?xAAxA?xAAxAAxA?xAAxA?xAAxA?zAAxAAxA?xAAxA?xAA?sB?sB?sB?sB?uB?sB?sB?sB@sB?sB?sB?sB?uB?sB?sB?sBh@AxA?xAAzA?xAAxA?xA?xAAzA?xAAxA?fB?fB?hB?fB?fB?l@?d@?dD?~AA~AA`B?~AA~AAdB?fB?dB?fB?dB?fBAdBCtBCxA?zA?xA?zA?xA?xA?zA?xA?xA?zA?xA?zA?xA?xA?zA?xA?zA?xA???yA?{A?yA?{A?yA?yA?{A?yA?{A?yA?yA?{A?yA?yA?{A?yA?{A?yA?uBB?|BA~B?|B?|BCfCAzC?lC@lC?lC?zBAxB?zB?zB?zBAxB?zB?lC?nC?lC?lC?tB?vB?tBAtB?tB?vB?tB?~AmB?mB@mB?kB@kB@kB@s@?}@?gB?gB?gB?g@?cB?aB?cB?{A?yAA_B?}A?_B?_B@_B?}A?_B?_B@aB?_B@_B?{B@{B?eB?gB@eB?eB?cA?c@AaCAaB@aB?_B@aB@aB?aB@aB?aB@_B@aB?aB@eB@cB@eB@eB?cB@eB@_DA?pA',
            indexedTimeData: null,
            elevationData: null,
            indexedElevationData:
              '?_omknBgE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE~hbEgE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE_ibEgE?gE~reKgE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE~hbEgE?gE?gE?gE?gE~hbEgE?gE?gE?gE?gE?gE?gE?gE~hbEgE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE~hbEgE_ibEgE?gE?gE?gE?gE~ugCgE_w|AgE_~i@gE~hbEgE?gE?gE_uu@gE_skCgE~hbEgE?gE?gE_ibEgE?gE?gE~hbEgE_~fDgE_jZgE?gE?gE?gE?gE?gEnbd@gE_pRgE~tu@gE?gE_uu@gE~oRgEobd@gE?gE?gE?gE?gE?gE~iZgE~}fDgE_ibEgE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gEohyCgEo_h@gE?gE?gE?gE_ibEgE?gE_ibEgE?gE?gE~hbEgEotiCgEosw@gE?gE_ibEgE?gE_ibEgE?gE?gE~hbEgE?gE?gE?gE?gE_klBgE?gE~jlBgE?gE?gE~mhBgE_nhBgE?gE?gE_ibEgE?gE?gE?gE?gE~hbEgE?gE?gE?gE?gE_fiAgE_bxBgE~hbEgE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE_ibEgE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE_bxBgE_fiAgE~iwCgE~}i@gE?gE?gE?gE?gE?gE_d_DgEonTgEotLgE?gE?gE?gEnj`EgEn}@gE?gE?gE?gE?gE?gEowHgEn}@gE~xFgE?gE?gE_jZgEo}}BgEo_h@gE?gE?gE?gEn_h@gEn}}BgE~iZgE?gE?gE_yFgEo}@gEnwHgE?gE?gE?gE?gE?gEo}@gEoj`EgE?gE?gE?gEntLgEnnTgE~c_DgE?gE?gE?gE?gE?gE_~i@gE_jwCgE~eiAgE~axBgE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE~hbEgE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE_ibEgE~axBgE~eiAgE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE_ibEgE?gE~{BgE~k~DgE_ibEgE?gE?gE?gE?gE?gE?gE~{BgE~k~DgE?gE?gE~|tAgE_}tAgE?gE?gE_klBgE?gE~jlBgE?gE?gE?gE~hbEgE?gE?gE?gE?gE_d|GgE_nhBgE~hbEgE~hbEgE?gE?gE?gE?gEostDgEotLgE?gE?gE~hbEgE?gE~hbEgE?gE_ibEgE?gE?gE?gE?gE?gE_pRgE~oRgE?gE?gE~hbEgE?gE?gE_ibEgEnj`EgEn}@gE_ibEgE~hbEgE?gE_uoHgE~jlBgE_ibEgE_klBgEn`zBgEn}wJgE?gE_ibEgE?gE~hbEgE?gEo}wJgEo`zBgE~jlBgE~hbEgE_klBgE~toHgE?gE_ibEgE~hbEgEo}@gEoj`EgE~hbEgE?gE?gE_ibEgE?gE?gE?gE?gE?gE?gE_ibEgE?gE?gE~hbEgE?gE?gE?gEnpxDgEnwHgE?gE_ibEgE_cmAgE_etBgE~hbEgE_{gHgE_w|AgE~hbEgE?gE?gE_ibEgE?gE?gE_ibEgE?gE?gE?gE?gE~hbEgE?gE_ibEgE?gE?gE?gE~hbEgE?gE_ozDgE_yFgE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE~hbEgE_ibEgE~hbEgE_ozDgEoxtIgEntiCgEopxDgEowHgEnr_FgEn_eDgE?gE?gE~hbEgE?gE_ibEgE?gE?gE~hbEgE?gE?gE?gE?gE?gE?gE~{BgE_|BgE?gE?'
          }
        }
      ],
      estimatedTimeToComplete: {
        value: '4.5–5',
        unit: 'hr'
      }
    },
    {
      id: 53450256002,
      status: 'A',
      sequence_num: 3,
      lineGeoStats: {
        distanceTotal: 1835.47,
        elevationGain: 3,
        elevationLoss: 6,
        elevationMax: 591,
        elevationMin: 588,
        elevationStart: 591,
        elevationEnd: 588,
        dateTimeStart: null,
        dateTimeStop: null
      },
      lineDisplayProperty: {
        color: '#eea82f'
      },
      lineSegments: [
        {
          id: 534502560020000,
          dateTimeStart: null,
          dateTimeStop: null,
          sequence_num: 1,
          freeDraw: null,
          polyline: {
            pointsData: '}awgFf}hzQxA@xA?zA@xA@xA?xA@zA?xA@@yA?}B?}B?}BA}B?}B?}B?}B@mC@kC@mCAeC?sB?qB@sB?qB?sB?sB?qB@sB?qB?sB?sB?qB@sB?qB?sB?K',
            indexedTimeData: null,
            elevationData: null,
            indexedElevationData:
              '?_udvoBgE?gE?gE?gE?gE~hbEgE?gE_ibEgE?gE?gE?gE~hbEgE?gE?gE~hbEgE_ibEgE_ibEgE?gE~hbEgE~hbEgE?gE?gE~hbEgE?gE?gE?gE_ibEgE_poCgE~ooCgE~hbEgE?gE?gE?gE?gE?gE?gE?'
          }
        }
      ],
      estimatedTimeToComplete: {
        value: '0.5–1',
        unit: 'hr'
      }
    },
    {
      id: 53450256003,
      status: 'A',
      sequence_num: 4,
      lineGeoStats: {
        distanceTotal: 1991.79,
        elevationGain: 0,
        elevationLoss: 0,
        elevationMax: 592,
        elevationMin: 591,
        elevationStart: 591,
        elevationEnd: 591,
        dateTimeStart: null,
        dateTimeStop: null
      },
      lineDisplayProperty: {
        color: '#a57ed8'
      },
      lineSegments: [
        {
          id: 534502560030000,
          dateTimeStart: null,
          dateTimeStop: null,
          sequence_num: 1,
          freeDraw: null,
          polyline: {
            pointsData: 'gv~gFrbmzQkB?iBA?gC?iC?gC?iCAwBAwBCwBAwBAwBAcCAcCAcCAmC?mCAmCf@@Z@@cCAuBAwBAuBAwBAuBAwBAuBCwBAuBAwBAuBAwBAuBAwBAuBAuC?wC',
            indexedTimeData: null,
            elevationData: null,
            indexedElevationData:
              '?_udvoBgE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE_ibEgE~hbEgE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?gE?'
          }
        }
      ],
      estimatedTimeToComplete: {
        value: '0.5–1',
        unit: 'hr'
      }
    },
    {
      id: 53450256004,
      status: 'A',
      sequence_num: 5,
      lineGeoStats: {
        distanceTotal: 1168.24,
        elevationGain: 2,
        elevationLoss: 3,
        elevationMax: 596,
        elevationMin: 594,
        elevationStart: 595,
        elevationEnd: 594,
        dateTimeStart: null,
        dateTimeStop: null
      },
      lineDisplayProperty: {
        color: '#f87559'
      },
      lineSegments: [
        {
          id: 534502560040000,
          dateTimeStart: null,
          dateTimeStop: null,
          sequence_num: 1,
          freeDraw: null,
          polyline: {
            pointsData: '{zqgFp|kzQ?}B?}B?}B@_C?}B?}B~A?~A?`B@~A?~A?~A?`B?~A?~A@~A?`B?~A?bB?zB?zB?',
            indexedTimeData: null,
            elevationData: null,
            indexedElevationData: '?_}qnpBgE_ibEgE~reKgE?gEocpJgE~hbEgEnylDgE?gE_ieAgE~heAgEopxDgEoj`EgE~qvDgE~hbEgE?gE?gE?gE?gE?gE?gE?gE?'
          }
        }
      ],
      estimatedTimeToComplete: {
        value: '0.5–1',
        unit: 'hr'
      }
    }
  ],
  waypoints: [
    {
      id: 109604656,
      name: 'test 1',
      name_lang: null,
      name_original: 'test 1',
      description: 'desc 1',
      description_lang: null,
      description_original: 'desc 1',
      order: 1,
      location: {
        latitude: 38.14434,
        longitude: -98.79372
      },
      at_map_id: 53450256,
      enable_translations: false,
      waypointDisplayProperty: {
        showTitle: true
      }
    },
    {
      id: 109604657,
      name: 'test 2',
      name_lang: null,
      name_original: 'test 2',
      description: 'desc 2',
      description_lang: null,
      description_original: 'desc 2',
      order: 2,
      location: {
        latitude: 38.14101,
        longitude: -98.78621
      },
      at_map_id: 53450256,
      enable_translations: false,
      waypointDisplayProperty: {
        showTitle: false
      }
    }
  ],
  mapPhotos: [],
  metadata: {
    created: '2025-04-07T19:33:47Z',
    updated: '2025-04-14T18:09:25Z',
    status: 'A',
    source: 1033,
    timezone: null,
    cursor: 'eyJjcmVhdGVkX2F0IjoiMjAyNS0wNC0wNyAxOTozMzo0NyIsImlkIjo1MzQ1MDI1NiwicmF0aW5nIjpudWxsfQ=='
  },
  estimatedTimeToComplete: {
    value: '8–9',
    unit: 'hr'
  }
} as unknown as CustomRouteMap; // The type only has properties needed for custom routes but the API returns a lot more properties
